// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as JsxRuntime from "react/jsx-runtime";
import * as Utils$OrcaPaymentPage from "../Utilities/Utils.bs.js";

function FullScreenDivDriver(props) {
  React.useEffect(() => {
    Utils$OrcaPaymentPage.messageParentWindow(undefined, [[
        "driverMounted",
        true
      ]]);
  }, []);
  return JsxRuntime.jsx("div", {});
}

let make = FullScreenDivDriver;

export {
  make,
}
/* react Not a pure module */
